export default function getPathPrefix() {
  if (document && document.getElementById) {
    const element = document.getElementById('path-prefix');

    return element && element.content ? element.content : '';
  }
}
